import React, { PureComponent, memo } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import _ from 'lodash';
import classNames from 'classnames';
import { Checkbox } from '@material-ui/core';

import './PermutationBet.scss';
import { select } from 'src/configs/store';
import formatOdds from '../../../utils/formatOdds';
import Icon from '../../Icon/Icon';
import StakeInput from '../../StakeInput/StakeInput';

class PermutationBet extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      combinationValues: {},
      betCombinations: 0
    };
  }

  componentDidMount() {
    const { combination, slip, singleSlip, accaSlip, systemSlip, startIndex } = this.props;

    let selectedSlip = singleSlip;
    if (slip === 1) selectedSlip = accaSlip;
    else if (slip === 2) selectedSlip = systemSlip;

    const values = _.reduce(JSON.parse(JSON.stringify(combination)), (accum, c, index) => {
      return { ...accum, [c.key]: selectedSlip.stakeSelection === 'differentStake' && slip !== 0 ?
        selectedSlip.stakes[startIndex + index] :
        c.stake };
    }, {});

    this.setState({ combinationValues: { ...this.state.combinationValues, ...values } });
  }

  componentDidUpdate(prevProps) {
    const { combination, slip, singleSlip, accaSlip, systemSlip, startIndex, stakes, index } = this.props;
    const isSelected = systemSlip.selectedCombinations?.some((selected) => selected === index);

    if (!_.isEqual(stakes, prevProps.stakes) || !_.isEqual(combination, prevProps.combination)) {
      let selectedSlip = singleSlip;
      if (slip === 1) selectedSlip = accaSlip;
      else if (slip === 2) selectedSlip = systemSlip;

      const values = _.reduce(JSON.parse(JSON.stringify(combination)), (accum, c, index) => {
        return { ...accum, [c.key]: selectedSlip.stakeSelection === 'differentStake' && slip !== 0 ?
          selectedSlip.stakes[startIndex + index] :
          c.stake };
      }, {});

      this.setState({ combinationValues: { ...this.state.combinationValues, ...values } });
    }

    if (!_.isEmpty(systemSlip.stakes)) {
      const betCombinations = this.calculateBetCombinations();

      if (isSelected &&
        systemSlip.stakeSelection === 'stakePerSystem' &&
      _.isEmpty(systemSlip.stakePerSystem)){
        this.props.updateBetStake({
          index: index-1,
          value: 5 });
      }

      this.setState({ betCombinations: betCombinations });
    }
  }

  calculateBetCombinations = () => {
    const { combination, systemSlip, startIndex } = this.props;

    const combinations = _.reduce(systemSlip.stakes, (sum, line, key) => {
      let newSum = 0;
      const lastIndex = startIndex + combination.length;

      if (line > 0 && key >= startIndex && key < lastIndex) {
        newSum = 1;
      }

      return sum + newSum;
    }, 0);
    return combinations;
  }

  onCombinationValueChange = (index) => (name, value) => {
    this.props.updateBetStake({ index, value: +value });
  }

  handleOpenAll = () => {
    const newCombinations = JSON.parse(JSON.stringify(this.props.openCombinations));

    if (this.props.openCombinations.includes(this.props.index - 1)) {
      const comboIndex = _.indexOf(this.props.openCombinations, this.props.index-1);
      newCombinations.splice(comboIndex, 1);
    } else {
      newCombinations.push(this.props.index -1);
    }

    this.props.changeReadOpenCombinations(newCombinations);
    this.props.setOpen(newCombinations);
  }

  renderChildren = () => {
    const { combination, selectedOddsType, allowStakes, stakes, startIndex, divisor, isSecondScreen } = this.props;

    return _.map(combination, (c, j) => {
      const stake = _.find(stakes, (stake) => stake.lines.toString() === c.key);
      const returnValue = stake?.return || stake?.maximumReturn;
      const className = isSecondScreen ? { className: 'permutation-bet-container-second-screen__table-row' } : {};

      return (
        <tr key={ j } { ...className }>
          <td width="25%">{ c.key }</td>
          <td width="25%">
            <StakeInput
              rule="sports.system"
              type="bet"
              name={ c.key }
              defaultValue={ (this.state.combinationValues[c.key] / divisor).toString() || '' }
              onChange={ this.onCombinationValueChange(startIndex + j) }
              disabled={ !allowStakes }
            />
          </td>
          <td width="25%">{ formatOdds(c.odds, selectedOddsType) }</td>
          <td width="25%">{ (returnValue && (returnValue / divisor)?.toFixed(2)) || '-.--' }</td>
        </tr>
      );
    });
  }

  onAmountChange = (name, value) => {

    this.props.updateBetStake({ index: this.props.index -1, value });
  };

  onHandleChange = e => {
    e.stopPropagation();
    const { systemSlip, addSelectedCombinations, index, removeSelectedCombination, updateBetStake } = this.props;
    const isChecked = _.indexOf(systemSlip.selectedCombinations, index) >= 0;

    if (isChecked && systemSlip.selectedCombinations.length > 1){
      removeSelectedCombination(index);
    } else if (!isChecked){
      addSelectedCombinations(index);
      if (systemSlip.stakeSelection === 'stakePerSystem'){
        updateBetStake({ index: index-1, value:this.props.stakingRules.sports.system.default });
      }
    }
  }

  onOpenCombination = e => {
    e.stopPropagation();
    const { systemSlip, addSelectedCombinations, index, updateBetStake } = this.props;
    const isChecked = _.indexOf(systemSlip.selectedCombinations, index) >= 0;
    if (!isChecked){
      addSelectedCombinations(index);
      if (systemSlip.stakeSelection === 'stakePerSystem'){
        updateBetStake({ index: index-1, value:this.props.stakingRules.sports.system.default });
      }
    }
  };

  render() {
    const { t, combination, name, systemSlip, index, combinations, slip, stakingRules, divisor, isSecondScreen } = this.props;
    const { combinationValues, betCombinations } = this.state;
    const isSelected = systemSlip.selectedCombinations?.some((selected) => selected === index);

    return (
      <div className={
        classNames({
          'permutation-bet-container__any-bet': true,
          'permutation-bet-container-second-screen': isSecondScreen
        })
      }
      >
        <div
          className={
            classNames({
              'permutation-bet-container__header': true,
              'permutation-bet-container-second-screen__header' : isSecondScreen
            })
          }
          { ...(!this.props.openCombinations.includes(this.props.index - 1) && { onClick: this.onOpenCombination }) }
        >
          <div className="permutation-bet-container__click" onClick={ this.handleOpenAll }>
            <div className="permutation-bet-container__icon-name">
              <Icon
                icon="arrow"
                className={
                  classNames({
                    'permutation-bet-container__arrow': true,
                    'permutation-bet-container__arrow--open': this.props.openCombinations.includes(this.props.index - 1)
                  })
                }
              />
              <div>{ name }
                {
                  (this.props.slip === 2 && this.props.systemSlip.selectedCombinations.includes(index)) &&
                  ` (${ t('betslip.betting') }
                  ${ betCombinations }/${ combination.length })`
                }
              </div>
            </div>
            <div>
              <span>
              </span>
            </div>
            {
              (slip !== 2 || systemSlip.stakeSelection !== 'stakePerSystem') &&
            <div className="permutation-bet-container__value">
              <span>{ t('betslip.stake') }: </span>
              {
                (_.isEmpty(combinationValues) || !this.props.systemSlip.selectedCombinations.includes(index)) ?
                  '0.00' :
                  _.reduce(Object.values(combinationValues), (total, v) => total += (v / divisor), 0).toFixed(2)
              }
            </div>
            }
          </div>
          {
            (slip === 2 && systemSlip.stakeSelection === 'stakePerSystem')  && isSelected &&
            <>
              <span>{ t('betslip.perCombination') }</span>
              <StakeInput
                rule="sports.single"
                type="betslip"
                onChange={ this.onAmountChange }
                defaultValue={ this.props.systemSlip?.stakePerSystem[index -1] / divisor || stakingRules.sports.system.default || 0 }
                name="amount"
                className="stake-options__stake-input"
              />
            </>
          }
          {
            this.props.slip === 2 && (
              <Checkbox
                className={
                  classNames({
                    'permutation-bet-container__checkbox': true,
                    'permutation-bet-container-second-screen__checkbox' : isSecondScreen
                  })
                }
                checked={ isSelected }
                indeterminate={ betCombinations !== combination.length && betCombinations !== 0 }
                checkedIcon={ <Icon icon="checked" /> }
                indeterminateIcon={ <Icon icon="less" /> }
                name="selected"
                color="default"
                onClick={ this.onHandleChange }
                disabled={ _.size(combinations) === 1 }
              />
            )
          }
        </div>
        {
          this.props.openCombinations.includes(this.props.index - 1) && (
            <table
              className={
                classNames({
                  'permutation-bet-container__table': true,
                  'permutation-bet-container-second-screen__table': isSecondScreen
                })
              }
              cellPadding="0"
              cellSpacing="0"
            >
              <tbody>
                <tr>
                  <th>{ !isSecondScreen ? t('betslip.selections') : t('secondScreen.bets') }</th>
                  <th>{ t('betslip.yourStake') }</th>
                  <th>{ t('betslip.yourOdds') }</th>
                  <th>{ !isSecondScreen ? t('betslip.payout') : t('secondScreen.potReturn') }</th>
                </tr>
                { this.renderChildren() }
              </tbody>
            </table>
          )
        }
      </div>
    );
  }

}

PermutationBet.propTypes = {
  t: PropTypes.func,
  combination: PropTypes.array,
  name: PropTypes.string,
  selectedOddsType: PropTypes.string,
  allowStakes: PropTypes.bool,
  open: PropTypes.bool,
  stakes: PropTypes.array,
  startIndex: PropTypes.number,
  updateBetStake: PropTypes.func,
  slip: PropTypes.number,
  singleSlip: PropTypes.object,
  accaSlip: PropTypes.object,
  stakingRules: PropTypes.object,
  systemSlip: PropTypes.object,
  index: PropTypes.number,
  addSelectedCombinations: PropTypes.func,
  removeSelectedCombination: PropTypes.func,
  combinations: PropTypes.object,
  openCombinations: PropTypes.array,
  setOpen: PropTypes.func,
  divisor: PropTypes.number,
  changeReadOpenCombinations: PropTypes.func,
  isSecondScreen: PropTypes.bool
};

const selection = select(state => ({
  combinations: state.betslip.combinations
}));

const mapState = state => ({
  selectedOddsType: state.odds.selectedOddsType,
  stakes: state.betslip.stakes,
  slip: state.betslip.slip,
  singleSlip: state.betslip.singleSlip,
  accaSlip: state.betslip.accaSlip,
  stakingRules: state.content.stakingRules,
  systemSlip: state.betslip.systemSlip,
  divisor: state.betslip.divisor,
  ...selection(state)
});

const mapDispatch = dispatch => ({
  updateBetStake: (obj) => dispatch.betslip.updateBetStake(obj),
  addSelectedCombinations: (number) => dispatch.betslip.addSelectedCombinations(number),
  removeSelectedCombination: (number) => dispatch.betslip.removeSelectedCombination(number),
  changeReadOpenCombinations: (obj) => dispatch.betslip.changeReadOpenCombinations(obj)
});

export default memo(connect(mapState, mapDispatch)(withTranslation('common')(PermutationBet)));
